/*global Modernizr, Splide, mowgli_config, MowgliSlideHideArrows */
/*jslint browser:true */

(function() {
    'use strict';

    var logo_sliders = document.querySelectorAll('.logo-slider');
    if(logo_sliders) {
      logo_sliders.forEach((logo_slider) => {
        const slider = new Splide(logo_slider, mowgli_config['pb_logo_grid']);

        slider.mount({ MowgliSlideHideArrows });
      });
    }
}());
